var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 7.5C17.4922 7.5 18.5 6.49219 18.5 5.25C18.5 4.00781 17.4922 3 16.25 3C15.0078 3 14 4.00781 14 5.25C14 6.49219 15.0078 7.5 16.25 7.5Z",
    fill: "#8F92B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1875 0H1.8125C1.08125 0 0.5 0.595313 0.5 1.32656V16.6734C0.5 17.4047 1.08125 18 1.8125 18H20.1875C20.9188 18 21.5 17.4047 21.5 16.6734V1.32656C21.5 0.595313 20.9188 0 20.1875 0ZM15.3547 9.26719C15.2141 9.10313 14.9984 8.97656 14.7547 8.97656C14.5156 8.97656 14.3469 9.08906 14.1547 9.24375L13.2781 9.98438C13.0953 10.1156 12.95 10.2047 12.7391 10.2047C12.5375 10.2047 12.3547 10.1297 12.2234 10.0125C12.1766 9.97031 12.0922 9.89062 12.0219 9.82031L9.5 7.09219C9.3125 6.87656 9.03125 6.74063 8.71719 6.74063C8.40313 6.74063 8.1125 6.89531 7.92969 7.10625L2 14.2594V2.04844C2.04688 1.72969 2.29531 1.5 2.61406 1.5H19.3812C19.7047 1.5 19.9672 1.73906 19.9859 2.0625L20 14.2687L15.3547 9.26719Z",
    fill: "#8F92B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/picture-icon.9ea29aae1292d4ced57597524b8080e3.svg";
export { ForwardRef as ReactComponent };